import React from 'react';
import HubblePageContainer from './components/HubblePageContainer';
import classes from './styles/style.module.css';

const items = [
   "/images/hubble/majors/1.png",
   "/images/hubble/majors/2.png",
   "/images/hubble/majors/3.png",
   "/images/hubble/majors/4.png",
   "/images/hubble/majors/5.png",
   "/images/hubble/majors/6.png",
   "/images/hubble/majors/7.png",
   "/images/hubble/majors/8.png",
   "/images/hubble/majors/9.png",
   "/images/hubble/majors/10.png",
]

const HubbleMajors = () => {
  return (
    <HubblePageContainer>
        <img src='/images/hubble/majors/majorsBanner.png' alt='majors' className='w-100 img-fluid' />
        <div className='row mt-4'>
            {
                items.map((item,index)=>{
                    return(
                        <div className='col-6'>
                            <div className={classes.majorContainer} key={index}>
                                <img src={item} alt='major-item' className='w-100 img-fluid' />
                            </div>
                        </div>
                    )
                })
            }
        </div>
    </HubblePageContainer>
  )
}

export default HubbleMajors